import { GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY } from './gravityWebsiteHandoffConstants.js';
import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';

const persistGravityWebsiteHandoff = (handoffId = '', now = Date.now()) => {
  const normalizedHandoffId = String(handoffId || '').trim();

  if (!isGravityWebsiteHandoffId(normalizedHandoffId) || typeof window === 'undefined') {
    return false;
  }

  try {
    const storage = window.sessionStorage;
    if (!storage) {
      return false;
    }

    const storedHandoff = JSON.parse(storage.getItem(GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY) || 'null');
    const ready = storedHandoff?.handoffId === normalizedHandoffId && storedHandoff?.ready === true;
    const savedAt = storedHandoff?.handoffId === normalizedHandoffId && Number.isFinite(storedHandoff?.savedAt) ? storedHandoff.savedAt : now;

    storage.setItem(
      GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY,
      JSON.stringify({
        handoffId: normalizedHandoffId,
        savedAt,
        ready
      })
    );
    return true;
  } catch {
    return false;
  }
};

export default persistGravityWebsiteHandoff;
